import { csx } from '@vtex/admin-ui'

const styles = {
  recurrenceTag: csx({
    marginRight: '$space-2',
    height: '1.5rem',
    padding: '$space-1',
  }),
  summaryContent: csx({ '> *': { verticalAlign: 'middle' } }),
}

export default styles
